export enum ShowTemplateType {
    FirstEmailTemplate = "FirstEmailTemplate",
    ReminderEmailTemplate = "ReminderEmailTemplate",
    ConfirmEmailTemplate = "ConfirmEmailTemplate",
    GroupEmailTemplate = "GroupEmailTemplate",
    TicketEmailTemplate = "TicketEmailTemplate",
    ConfirmSmsTemplate = "ConfirmSmsTemplate",
    ReminderSmsTemplate = "ReminderSmsTemplate"
}

export const ShowTemplateTypeNames: { [key in ShowTemplateType]: string } = {
    [ShowTemplateType.FirstEmailTemplate]: "First Email Template",
    [ShowTemplateType.ReminderEmailTemplate]: "Reminder Email Template",
    [ShowTemplateType.ConfirmEmailTemplate]: "Confirmation Email Template",
    [ShowTemplateType.GroupEmailTemplate]: "Group Email Template",
    [ShowTemplateType.TicketEmailTemplate]: "Ticket Email Template",
    [ShowTemplateType.ConfirmSmsTemplate]: "Confirmation SMS Template",
    [ShowTemplateType.ReminderSmsTemplate]: "Reminder SMS Template"
};
